import { createContext, useContext } from 'react'

const TestModeContext = createContext(false)

export const TestModeProvider = TestModeContext.Provider

export function useTestMode() {
  return useContext(TestModeContext)
}
